import React from 'react'
import {Layout, Row, Button, Col,Empty, Tag, Space,Avatar, Input} from 'antd';
export default class Footer extends React.Component {

    render () {
        return (
            <div>
                <Space>
                    Copyright © shreade <a target="_blank" href="http://beian.miit.gov.cn" rel="noopener noreferrer">京ICP备2020040661号</a>
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042974" rel="noopener noreferrer">京公网安备 11010502042974号</a>
                </Space>
            </div>
        )
    }
}